import { render, staticRenderFns } from "./AdminsTable.vue?vue&type=template&id=9ebd2980&"
import script from "./AdminsTable.vue?vue&type=script&lang=js&"
export * from "./AdminsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports